var matchKeys = ['country_code', 'number', 'extension']
var numbersOnly = require('./numbers-only')

/**
 * A function to parse phone number strings into an object representing
 * the distinct parts (country code, number, extension).
 *
 * @param str
 * @returns {object|boolean} An object with possible keys: country_code, number, extension - else false if no parsable match
 */
function parsePhoneNumber(str = '') {
  if (typeof str !== 'string' || !str) {
    str = ''
  }

  /**
   * This ensures that if an empty string is passed in or something that is not a string or null then false is returned
   * This logic is sloppy and the tests and expected API need to be developed so that null or undefined are returned but
   * for now to prevent other applications that use this from breaking by just returning false (override).
   */
  if (str === '') {
    return false
  }

  // remove formatting that might remain on old data
  const unformatted = str && str.toString().replace(/[()\-.]\s?/g, '')
  let matches = unformatted.match(/^(\+\d{0,6} ?)?(\d*)( \d*)?$/)

  const rv =
    matches &&
    matches.slice(1).reduce(function(obj, val, i) {
      if (val) obj[matchKeys[i]] = numbersOnly(val)
      return obj
    }, {})

  // If rv is defined then it has the formatted number data else return false
  // Again this needs rework but will break application code that uses this API
  return rv ? rv : false
}

module.exports = parsePhoneNumber
